import { FC } from "react"
import { ContactUsPage } from "../../../components/LandingPage/ContactUsPage"

export const LandingContactUsPage: FC = () => {
  return <ContactUsPage />
}
